<template>
  <main class="wrapper">
    <div class="container outcome-content-container">
      <a class="back-button btn btn-default-back" :href="backButtonLink" data-test="pg-back-button">
        {{ backButtonText }}
      </a>
      <transition name="fade" mode="out-in">
        <router-view @update-stepper="updateStepper" @hide-stepper="hideStepper" />
      </transition>
      <div v-if="displayStepper" class="stepper">
        <Stepper
          v-if="step !== undefined"
          :completed-step="computedStep"
          :steps-count="3"
          :show-tooltip="false"
        />
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import Stepper from "../../components/team-outcomes/progress-stepper.vue";

const step = ref<number>(-1);

const displayStepper = ref(true);

const route = useRoute();

const backButtonLink = computed<string>(() => {
  const routeName = route?.name;
  switch (routeName) {
    case "selectPersonalPathway":
      return "/my/outcomes/select";
    case "personalPathwaySummary":
      return `/my/outcomes/outcome/${route.params.outcomeUid}/select`;
    case "selectPersonalOutcome":
    default:
      return "/home?view=MyDashboard";
  }
});

const backButtonText = computed<string>(() => {
  return route?.name === "selectPersonalOutcome" ? "My Dashboard" : "Back";
});

const computedStep = computed<number>(() => {
  return step.value;
});

const updateStepper = (routeName: string): void => {
  switch (routeName) {
    case "selectPersonalOutcome":
      step.value = -1;
      break;
    case "selectPersonalPathway":
      step.value = 0;
      break;
    case "personalPathwaySummary":
      step.value = 1;
      break;
    default:
      step.value = -1;
      break;
  }
};

const hideStepper = (): void => {
  displayStepper.value = false;
};
</script>

<style scoped lang="less">
@import (reference) "../../styles/bootstrap/variables";
@import "../../styles/outcomes/outcomes-view";
</style>
